<script>
export default {
    name: 'AppSidebarCopyright',
};
</script>

<script setup>
defineProps({
    collapsed: {
        type: Boolean,
    },
});

const year = new Date().getFullYear();
</script>

<template>
    <base-tooltip tooltip-class="flex flex-col gap-y-2 p-4">
        <div
            class="flex cursor-help items-center justify-center text-xs text-white/50 duration-500 transition-spacing"
            :class="{
                'pl-3.5 gap-x-3.5': collapsed,
                'gap-x-1': !collapsed,
            }"
        >
            <base-icon
                class="h-3 w-3 shrink-0 transition-spacing"
                name="copyright"
                prefix="far"
            />
            <span class="overflow-hidden whitespace-nowrap leading-none">{{ year }} SyncMatters</span>
        </div>

        <template #content>
            <span>Copyright {{ year }} © SyncMatters, Inc.</span>
            <span>All Rights Reserved | Patent Pending</span>
        </template>
    </base-tooltip>
</template>
